<style scoped>
.modalbox-content {
  margin: 10px 0;
}

.modal-footer-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 20px;
  border-top: 1px solid #d8dbe0;
  background: #f9f9fb;
}

.footer-left {
  display: flex;
  align-items: center;
  gap: 8px;
}

.footer-left label {
  margin: 0;
  font-weight: 500;
  font-size: 13px;
  cursor: pointer;
}

.footer-left .erp-hint {
  font-size: 11px;
  color: #888;
  margin-left: 4px;
}

.footer-right {
  display: flex;
  gap: 8px;
}
</style>

<style>
/* Remove o scroll interno do conteúdo da modal de produto — conteúdo
   fica fluído e quem rola é o overlay externo (graças a scrollable=true). */
.modalbox.produto-modalbox .nav-tabs-boxed .tab-content {
  max-height: none !important;
  overflow: visible !important;
}

.modalbox.produto-modalbox > .modalbox-content {
  max-height: none !important;
  overflow: visible !important;
}

/* Permite que dropdowns dentro da modal de produto escapem da borda do
   .v--modal-box (que tem overflow:hidden por padrão na lib vue-js-modal). */
.v--modal-overlay:has(.produto-modalbox) .v--modal-box {
  overflow: visible !important;
}
</style>

<template>
<modal name="produtoEdit" height="auto" width="1100" :lazy="true" :scrollable="true" :clickToClose="false">
  <CloseModal :close="close" />
  <div class="modalbox produto-modalbox">
    <div class="xrow">
      <div class="col-1-1">
        <h2 class="text-bold text-gray-dark">
          {{item.id}} - {{item.descNF}}
        </h2>
      </div>
    </div>
    <CTabs variant="tabs" class="nav-tabs-boxed">
      <CTab title="Informações Gerais">
        <InformacoesGerais :item="item" :camposSincronizados="camposSincronizados" />
      </CTab>
      <CTab title="Características">
        <Caracteristicas :item="item" :camposSincronizados="camposSincronizados" />
      </CTab>
      <CTab title="Variações">
        <Variacoes :item="item" :camposSincronizados="camposSincronizados" />
      </CTab>
      <CTab title="Acesso e Tributação">
        <AcessoTributacao :item="item" :camposSincronizados="camposSincronizados" />
      </CTab>
      <CTab title="Conteúdo">
        <Conteudo :item="item" :camposSincronizados="camposSincronizados" />
      </CTab>
      <CTab title="Imagens e Vídeos">
        <Imagens
          :imagens="imagens"
          :item="item"
          :errorMessage="errorMessage"
          :remove="remove"
          :upload="upload"
          :uploading="uploading"
          :uploadLabel="uploadLabel"
        />
      </CTab>
      <CTab
        title="Preços"
        v-if="loadAuthorizationAction('ADMIN_PRODUTO', 'PRODUTO_VER_PRECOS')"
      >
        <Precos :item="item" />
      </CTab>
      <CTab
        title="Estoques"
        v-if="loadAuthorizationAction('ADMIN_PRODUTO', 'PRODUTO_VER_ESTOQUES')"
      >
        <Estoques :item="item" />
      </CTab>
      <CTab
        title="Pedidos emitidos"
        v-if="loadAuthorizationAction('ADMIN_PRODUTO', 'PRODUTO_VER_PEDIDOS')"
      >
        <Pedidos :item="item" />
      </CTab>
      <CTab
        title="Orçamentos"
        v-if="loadAuthorizationAction('ADMIN_PRODUTO', 'PRODUTO_VER_ORCAMENTOS')"
      >
        <Orcamentos :item="item" />
      </CTab>
      <CTab title="Similares">
        <Similares :item="item" />
      </CTab>
    </CTabs>
  </div>
  <div class="modal-footer-bar">
    <div class="footer-left">
      <input type="checkbox" id="persistirErp" v-model="persistirErp" />
      <label for="persistirErp">Persistir no ERP</label>
      <span class="erp-hint">(Nem todos os ERPs são compatíveis com essa funcionalidade)</span>
    </div>
    <div class="footer-right">
      <CButton variant="outline" color="secondary" @click="onClose">Cancelar</CButton>
      <CButton color="primary" @click="_onSave">Salvar</CButton>
    </div>
  </div>
</modal>
</template>

<script>
import * as cdn from "../../helpers/url";
import fs from "path";
import { baseName } from "../../helpers/utils";
import { post, del } from "@/helpers/apiRequest";
import { loadAuthorizationAction } from "@/helpers/cargas";
import CloseModal from "../../components/CloseModal";

import InformacoesGerais from "./Edit/InformacoesGerais";
import Caracteristicas from "./Edit/Caracteristicas";
import Variacoes from "./Edit/Variacoes";
import AcessoTributacao from "./Edit/AcessoTributacao";
import Conteudo from "./Edit/Conteudo";
import Imagens from "./Edit/Imagens";
import Precos from "./Edit/Precos";
import Estoques from "./Edit/Estoques";
import Pedidos from "./Edit/Pedidos";
import Orcamentos from "./Edit/Orcamentos";
import Similares from "./Edit/Similares";

function removeExtenton(fileName){
  let name =  fileName;
  let indexExtention  = name.lastIndexOf('.');
  let sliceLength     = name.length - indexExtention;
  sliceLength = -sliceLength;

  return name.slice(0, sliceLength);
}

function getExtenton(fileName)
{
  return fileName.split('.').pop();
}

export default {
  name: "produtoEdit",
  components: {
    CloseModal,
    InformacoesGerais,
    Caracteristicas,
    Variacoes,
    AcessoTributacao,
    Conteudo,
    Imagens,
    Precos,
    Estoques,
    Pedidos,
    Orcamentos,
    Similares,
  },
  watch: {
    "item.id": function(id) {
      this.imagens = [];
      this.loadImages(id);
    },
  },
  props: ["onSave", "item", "close", "camposSincronizados"],
  data() {
    return {
      activeTab: 1,
      persistirErp: false,
      errorMessage: null,
      imagens: [],
      uploading: false,
      uploadProgress: { current: 0, total: 0 },
    };
  },
  filters: {
    baseName(url) {
      return baseName(url);
    },
  },
  computed: {
    uploadLabel() {
      if (this.uploading) {
        return `Enviando ${this.uploadProgress.current}/${this.uploadProgress.total}...`;
      }
      return "Adicionar Imagens";
    },
  },
  methods: {
    loadAuthorizationAction,
    onClose() {
      this.clearData();
      this.close();
    },
    _onSave() {
      this.onSave(this.persistirErp);
      this.clearData();
    },
    loadImages(id) {
      fetch(`${cdn.cdnApi(id)}`)
        .then((res) => res.json())
        .then((res) => {
          const images = [];
          if (!!res.data) {
            res.data.all.map((path) => {
              images.push(cdn.cdnUrl(path));
            });
          }
          this.imagens = images;
        });
    },
    async upload(event) {
      const id = this.item.id;
      const files = Array.from(event.target.files);

      if (files.length === 0) return;

      this.uploading = true;
      this.uploadProgress = { current: 0, total: files.length };

      const errors = [];

      for (const file of files) {
        const name = removeExtenton(file.name);
        const formData = new FormData();
        formData.append("imagem", file);

        try {
          await post(`/admin/cdn/produtos/${id}/${name}`, formData, { isFile: true });
        } catch (error) {
          errors.push(`${file.name}: ${error.message}`);
        }

        this.uploadProgress.current++;
      }

      event.target.value = "";
      this.uploading = false;
      this.loadImages(this.item.id);

      if (errors.length === 0) {
        this.$swal({
          title: "Sucesso!",
          text: files.length === 1
            ? "Imagem enviada com sucesso ao repositório!"
            : `${files.length} imagens enviadas com sucesso ao repositório!`,
          showConfirmButton: true,
          icon: "success",
        });
      } else if (errors.length < files.length) {
        this.$swal({
          title: "Upload parcial",
          html: `${files.length - errors.length} imagem(ns) enviada(s), ${errors.length} falha(s):<br><small>${errors.join("<br>")}</small>`,
          showConfirmButton: true,
          icon: "warning",
        });
      } else {
        this.$swal({
          title: "Ops!",
          html: `Falha ao enviar todas as imagens:<br><small>${errors.join("<br>")}</small>`,
          showConfirmButton: true,
          icon: "error",
        });
      }
    },
    remove(path) {
      const id        = this.item.id;
      const name      = removeExtenton( fs.basename(path));
      const extension = getExtenton(fs.basename(path));

      del(`/admin/cdn/produtos/${id}/${name}/${extension}`)
        .then((response) => response.status)
        .then((status) => this.loadImages(this.item.id));
    },
    clearData() {
      this.errorMessage = null;
      this.activeTab = 1;
      this.persistirErp = false;
      this.uploading = false;
      this.uploadProgress = { current: 0, total: 0 };
    },
  },
  mounted() {
    this.clearData();
  },
};
</script>
